export default "__VITE_ASSET__DtsPRvqT__"